/* CraftPK collection page: AJAX filters, sort, load more, drawer, grid size */
(function () {
  if (window.cpCollectionReady) return; window.cpCollectionReady = true;
  var KEY = 'cpGridCols';
  var busy = null, priceTimer = null;

  function root() { return document.querySelector('[data-cp-col]'); }
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }

  function applyCols() {
    var r = root(); if (!r) return;
    var grid = r.querySelector('[data-cp-grid]');
    var saved = store(KEY);
    var btns = r.querySelectorAll('[data-cp-cols]');
    var cur = saved || (grid ? getComputedStyle(grid).getPropertyValue('--cp-cols-d').trim() : '3') || '3';
    if (grid && saved) grid.style.setProperty('--cp-cols-d', saved);
    btns.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-cp-cols') === String(cur)); });
  }

  function paramsFromForm(form) {
    var fd = new FormData(form), p = new URLSearchParams();
    fd.forEach(function (v, k) { if (String(v).trim() !== '') p.append(k, v); });
    return p.toString();
  }

  function render(url, push) {
    var r = root(); if (!r) return;
    var sid = r.getAttribute('data-section');
    var openKeys = [];
    r.querySelectorAll('details.cp-facet[open]').forEach(function (d) { openKeys.push(d.getAttribute('data-key')); });
    var drawerOpen = document.documentElement.classList.contains('cp-drawer-open');
    var scroller = r.querySelector('[data-cp-facets]'); var st = scroller ? scroller.scrollTop : 0;
    r.classList.add('is-loading');
    if (busy) busy.abort();
    busy = new AbortController();
    var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sid);
    fetch(fetchUrl, { signal: busy.signal, credentials: 'same-origin' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cp-col]');
        if (!fresh) { window.location.href = url; return; }
        fresh.querySelectorAll('details.cp-facet').forEach(function (d) {
          if (openKeys.indexOf(d.getAttribute('data-key')) > -1) d.setAttribute('open', '');
        });
        r.replaceWith(fresh);
        var sc = fresh.querySelector('[data-cp-facets]'); if (sc) sc.scrollTop = st;
        if (drawerOpen) document.documentElement.classList.add('cp-drawer-open');
        applyCols();
        if (push !== false) history.replaceState({}, '', url);
      })
      .catch(function (e) { if (e.name !== 'AbortError') window.location.href = url; });
  }

  function submit(form) {
    var q = paramsFromForm(form);
    render(form.getAttribute('action') + (q ? '?' + q : ''));
  }

  document.addEventListener('change', function (e) {
    var form = e.target.closest && e.target.closest('[data-cp-form]');
    if (!form) return;
    if (e.target.matches('[data-cp-price]')) return;
    submit(form);
  });
  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-cp-price]')) return;
    var form = e.target.closest('[data-cp-form]');
    clearTimeout(priceTimer); priceTimer = setTimeout(function () { submit(form); }, 700);
  });
  document.addEventListener('submit', function (e) {
    if (!e.target.matches('[data-cp-form]')) return;
    e.preventDefault(); submit(e.target);
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    var link = t.closest && t.closest('[data-cp-link]');
    if (link && root()) { e.preventDefault(); render(link.getAttribute('href')); return; }

    var more = t.closest && t.closest('[data-cp-loadmore]');
    if (more) {
      e.preventDefault();
      var r = root(); var sid = r.getAttribute('data-section'); var href = more.getAttribute('href');
      more.classList.add('is-loading'); more.textContent = 'Loading…';
      fetch(href + (href.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sid), { credentials: 'same-origin' })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var items = doc.querySelectorAll('[data-cp-grid] > .cp-grid__item');
          var grid = r.querySelector('[data-cp-grid]');
          items.forEach(function (it, i) { it.style.animationDelay = (i * 40) + 'ms'; grid.appendChild(it); });
          var wrap = r.querySelector('.cp-more-wrap'); var freshWrap = doc.querySelector('.cp-more-wrap');
          if (wrap && freshWrap) wrap.replaceWith(freshWrap);
        })
        .catch(function () { window.location.href = href; });
      return;
    }

    var colBtn = t.closest && t.closest('[data-cp-cols]');
    if (colBtn) { store(KEY, colBtn.getAttribute('data-cp-cols')); applyCols(); return; }

    var moreOpts = t.closest && t.closest('[data-cp-more]');
    if (moreOpts) { var ul = moreOpts.previousElementSibling; if (ul) ul.classList.remove('is-long'); moreOpts.remove(); return; }

    if (t.closest && t.closest('[data-cp-drawer-open]')) { document.documentElement.classList.add('cp-drawer-open'); return; }
    if (t.closest && t.closest('[data-cp-drawer-close]')) { document.documentElement.classList.remove('cp-drawer-open'); return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') document.documentElement.classList.remove('cp-drawer-open'); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyCols); else applyCols();
  document.addEventListener('shopify:section:load', applyCols);
})();